import { Space } from 'farmhub-ui-core';
import styled from 'styled-components';

export const Wrapper = styled.div<{
  height?: string;
  width?: string;
  padding?: string;
  styles?: any;
}>`
  height: ${p => p.height || 'fit-content'};
  width: ${p => p.width || '100%'};
  background: #fff;
  border-radius: ${props => props.theme.radius.md};
  padding: ${p => p.padding || '24px 18px'};

  ${p => p.styles}
`;

export const Content = styled.div<{
  padding?: string;
}>`
  width: 100%;
  padding: ${p => p.padding || '0px'};
  & > ${Space}:last-child {
    display: none;
  }
`;
